@switch (route) {
  @case ('/events/tickets') {
    <p class="m-auto font-semibold">My tickets</p>
    <img alt="logo" class="h-14" [src]="logo" />
  }

  @default {
    <div class="flex content-center items-center justify-center">
      <img alt="logo" class="h-[50px] w-[70px] pl-4" [src]="logo" />
    </div>

    @if (selectedEvent) {
      <div class="flex flex-col pl-4">
        <h1 class="m-0 p-0 text-sm font-semibold">
          {{ selectedEvent.venueName }}
        </h1>
        <p class="text-main-grey text-xs">
          {{ selectedEvent.description }}
        </p>
        <p class="text-main-grey text-xs">
          {{ selectedEvent.date | date: 'medium' }}
        </p>
      </div>
    }
  }
}
